import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { createTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function RadioButtonGroup(props: any) {
  // const { name, label, value, options, onChange, key } = props;
  const { name, label, value, options, onChange } = props;
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <FormControl component="fieldset" style={{ width: "100%" }}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label={name}
        name={name}
        value={value}
        onChange={onChange}
       // key={key}
        className="atomic-radio-group"
      >
        {options.map((options: { ID: number; ResponseText: string }) => (
          <FormControlLabel
           // key={options.ResponseText}
            key={options.ID}
            className={`radio-buttons ${
              isSmallScreen ? "small-screen-label" : ""
            }`}
            value={options.ResponseText}
            control={<Radio id={`${name}-${options.ID}`} />}
            label={isSmallScreen ? options.ResponseText : ""}
            onChange={onChange}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
